import React from 'react';
import styled from 'styled-components';
import { Modal } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import UpdateStaffForm from '../UpdateStaffForm';
import { StaffEntity } from '../../@types/mysqlEntities';

const StyledModal = styled(Modal)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const Content = styled.div`
    height: calc(100% - 100px);
    width: calc(100% - 100px);
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
`;

type Props = {
    isOpended: boolean;
    onClose: () => void;
    data: StaffEntity;
    onDelete: () => void
};

const StaffUpdateModal: React.FC<Props> = ({ isOpended, onClose, data, onDelete }) => {
    return (
        <StyledModal open={isOpended} onClose={onClose}>
            <Content>
                <UpdateStaffForm isOpended={isOpended} onClose={onClose} staff={data} onDelete={onDelete} />
            </Content>
        </StyledModal>
    );
};

export default observer(StaffUpdateModal);
